var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCreatedBy01 = function SvgCreatedBy01(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "created_by-01_svg2__a",
    x1: 33.28,
    x2: 169.79,
    y1: 173.98,
    y2: 22.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a70095"
  })))), /*#__PURE__*/React.createElement("path", {
    d: "M170.71 29.29C151.82 10.4 126.71 0 100 0S48.18 10.4 29.29 29.29 0 73.29 0 100s10.4 51.82 29.29 70.71S73.29 200 100 200s51.82-10.4 70.71-29.29S200 126.71 200 100s-10.4-51.82-29.29-70.71M43.4 167.69c3.3-28.41 27.73-50.35 56.6-50.35 15.22 0 29.53 5.93 40.3 16.69 9.09 9.1 14.83 20.97 16.31 33.65-15.34 12.84-35.08 20.59-56.6 20.59s-41.26-7.74-56.6-20.59Zm56.6-62.41c-16.75 0-30.37-13.63-30.37-30.37S83.26 44.54 100 44.54s30.37 13.62 30.37 30.37-13.63 30.37-30.37 30.37m66.69 52.51a68.66 68.66 0 0 0-18.11-32.03c-7.2-7.2-15.72-12.61-25.02-15.99 11.17-7.58 18.53-20.38 18.53-34.86 0-23.21-18.88-42.09-42.09-42.09S57.91 51.7 57.91 74.91c0 14.49 7.36 27.29 18.54 34.87a68.65 68.65 0 0 0-23.27 14.27c-9.86 9.18-16.7 20.88-19.88 33.73-13.44-15.5-21.59-35.7-21.59-57.78.01-48.68 39.61-88.28 88.29-88.28s88.28 39.6 88.28 88.28c0 22.08-8.15 42.29-21.59 57.79",
    style: {
      fill: "url(#created_by-01_svg2__a)"
    }
  }));
};
export default SvgCreatedBy01;